// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13sCC","textarea":"styles_textarea__2Imis"};